import { Outlet, Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/use-auth';

const AuthGuard = () => {
    const { isAuthenticated } = useAuth();

    return isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate to='/login' replace={true} />
    );
};

export default AuthGuard;
